import {Component, EventEmitter, Input, OnDestroy, OnInit} from '@angular/core';
import {ApiService} from "../../../services/api.service";
import {QRCode} from "../../../models/QRCode";
import {BehaviorSubject, Subscription} from "rxjs";
import {TicketTypeFormComponent} from "../../../pages/core/events/ticket-type-form/ticket-type-form.component";
import {NzModalService} from "ng-zorro-antd/modal";
import {QrcodeFormComponent} from "../components/qrcode-form/qrcode-form.component";
import {environment} from "../../../../environments/environment";
import {TenantService} from "../../../services/tenant.service";
import {QrEnlargeComponent} from "../components/qr-enlarge/qr-enlarge.component";

@Component({
  selector: 'qr-code-manager',
  templateUrl: './qr-code-manager.component.html',
  styleUrls: ['./qr-code-manager.component.scss']
})
export class QrCodeManagerComponent implements OnInit, OnDestroy {

  @Input() type!: 'event' | 'campaign';
  @Input() typeID!: string | undefined;

  codes: BehaviorSubject<QRCode[]> = new BehaviorSubject<QRCode[]>([]);
  $loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  codesUpdated: EventEmitter<any> = new EventEmitter<any>();
  createdSubscription: Subscription;

  constructor(
    private api: ApiService,
    private modal: NzModalService,
    private tenant: TenantService
  ) { }

  ngOnInit(): void {
    this.getCodes();

    this.createdSubscription = this.codesUpdated.subscribe((data)=>{
      this.getCodes();
    })
  }

  ngOnDestroy() {
    this.createdSubscription?.unsubscribe();
  }

  getCodes(): void{
    this.api.apiGet('core/' + this.type + 's/' + this.typeID + '/codes').then((GetCodesResult) =>  {
       this.codes.next(GetCodesResult);
       this.$loading.next(false);
    }).catch((GetCodeError) => {

    })
  }

  generateQRImage(code: QRCode){
    return environment.media_server + 'qr-codes/' + this.tenant.currentTenantValue + '/codes/' + code.id + '?size=400&timestamp=' + (new Date()).getTime();
  }

  enlargeQR(code: QRCode){

    this.modal.create({
      nzTitle: 'Enlarge ' + this.type + ' QRCode',
      nzContent: QrEnlargeComponent,
      nzFooter: null,
      nzWidth: '700px',
      nzClassName: 'newCustomerModal',
      nzMaskClosable: false,
      nzAfterClose: this.codesUpdated,
      nzComponentParams: {
        type: this.type,
        typeID: this.typeID,
        imagePath: this.generateQRImage(code),
        code
      }
    });


  }

  updateCode(code: QRCode): void {

    this.modal.create({
      nzTitle: 'Add new ' + this.type + ' QRCode',
      nzContent: QrcodeFormComponent,
      nzFooter: null,
      nzWidth: '700px',
      nzClassName: 'newCustomerModal',
      nzMaskClosable: false,
      nzAfterClose: this.codesUpdated,
      nzComponentParams: {
        type: this.type,
        typeID: this.typeID,
        code
      }
    });

  }

  addCode(): void {

    this.modal.create({
      nzTitle: 'Add new ' + this.type + ' QRCode / Link',
      nzContent: QrcodeFormComponent,
      nzFooter: null,
      nzWidth: '700px',
      nzClassName: 'newCustomerModal',
      nzMaskClosable: false,
      nzAfterClose: this.codesUpdated,
      nzComponentParams: {
        type: this.type,
        typeID: this.typeID
      }
    });

  }
}
